export default theme => {
  return {
    SuggestionHighlight: {
      color: (theme as any).palette.custom.primary,
      fontWeight: 'bold',
      backgroundColor: 'transparent',
    },
  };
};
